import { render, staticRenderFns } from "./outrightMatch.vue?vue&type=template&id=30302679"
import script from "./outrightMatch.vue?vue&type=script&lang=js"
export * from "./outrightMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports